import { DatePicker, FileInput, Textarea } from '@/components/Form'
import { FileType } from '@/features/files/constants/FileType'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import VendorUploadFrameAgreementTable from './VendorUploadFrameAgreementTable'

import { useWatch } from 'react-hook-form'
import { SourcingPostType } from '@eapproval/offer-shared'

const VendorUploadFrameAgreementSection = ({ canUpload, requestType }) => {
  const { t, i18n } = useTranslation()

  // const frameAgreementDetails = useWatch({ name: 'frameAgreementDetails' })

  return (
    <>
      {/* <DatePicker
        name={'validDate'}
        isRow
        label={t('VENDOR_UPLOAD_PAGE_VALID_DATE')}
        disabled={!canUpload || requestType === SourcingPostType.REQUEST_FOR_TECHNICAL_SUPPORT_DOCUMENT}
      /> */}
      <FileInput
        label={t('VENDOR_UPLOAD_PAGE_REFERENCE_FRAME_AGREEMENT')}
        name="referenceFrameAgreements"
        fileType={FileType.SOURCING_FRAME_AGREEMENT}
        isRow
        disabled={true}
        isRequired={false}
      />
      <FileInput
        label={t('VENDOR_UPLOAD_PAGE_FRAME_AGREEMENT')}
        name="frameAgreements"
        fileType={FileType.SOURCING_FRAME_AGREEMENT}
        isRow
        disabled={!canUpload || requestType === SourcingPostTypeSourcingPostType.REQUEST_FOR_TECHNICAL_SUPPORT_DOCUMENT}
        isMultiple
        canRemove
      />

      <Textarea
        name={`vendorRemark`}
        label={t('VENDOR_UPLOAD_PAGE_REMARKS')}
        disabled={!canUpload || requestType === SourcingPostType.REQUEST_FOR_UPDATE_OF_TERMS}
        isRequired={false}
      />

      {/* <VendorUploadFrameAgreementTable data={frameAgreementDetails} disabled={!canUpload} /> */}
    </>
  )
}

export default VendorUploadFrameAgreementSection
